import styled from 'styled-components';
import { EmptyStateSegment } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { spacing } from 'ui/theme';
import { useTranslation } from '../../hooks';

const EmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  min-height: ${spacing.x24};
`;

export const testIds = { emptyState: 'segmentation-insights-table-empty-state' };

export const NoResultsEmptyState = ({ title, subtitle }: { title?: string; subtitle?: string }) => {
  const { t } = useTranslation();
  return (
    <EmptyStateWrapper data-test={testIds.emptyState}>
      <EmptyState
        Illustration={EmptyStateSegment}
        title={title || t('emptyState.title')}
        subtitle={subtitle || t('emptyState.subtitle')}
      />
    </EmptyStateWrapper>
  );
};
